import * as React from "react"

interface BubbleIconProps {
    color?: string;
    size?: number;
}

function Bubble(props: BubbleIconProps) {
    const { color = "#fff", size = 24, ...restProps } = props;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            {...restProps}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.461 0C6.1 0 .923 4.208.923 9.38c0 1.144.254 2.24.717 3.253C.58 13.71 0 15.043 0 16.454c0 1.616.779 3.155 2.154 4.29v2.313c0 .363.203.693.524.85a.903.903 0 00.976-.113l1.804-1.474c.634.141 1.28.213 1.928.213 3.104 0 5.806-1.548 6.89-3.895a13.857 13.857 0 001.5-.278l3.187 2.604a.907.907 0 00.976.113.946.946 0 00.524-.85v-4.093C22.716 14.37 24 11.933 24 9.38 24 4.208 18.824 0 12.462 0zM5.48 20.383a.909.909 0 00-.821.173l-.659.539v-.82a.95.95 0 00-.395-.774c-1.133-.809-1.758-1.891-1.758-3.047 0-.761.281-1.502.8-2.15 1.961 2.572 5.408 4.32 9.36 4.446-1.007 1.156-2.73 1.895-4.622 1.895a7.061 7.061 0 01-1.905-.262zm13.532-5.502a.952.952 0 00-.395.774v2.609l-2.047-1.673a.908.908 0 00-.821-.173c-1.075.302-2.18.455-3.287.455-5.344 0-9.692-3.362-9.692-7.494s4.348-7.493 9.692-7.493c5.345 0 9.693 3.362 9.693 7.494 0 2.073-1.146 4.077-3.144 5.502zM9 7a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2h-6z"
                fill={color}
            />
        </svg>
    )
}

export default Bubble
